export const data = [
  {
    label: "Beach",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/si-nanti-snorkeling-35248",
    passion: "beach",
  },
  {
    label: "Arts & Culture",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/mc-pardt-art-gallery-723508487-38328",
    passion: "culture",
  },
  {
    label: "Winter Sports",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/tx-szgjf-skiing-31248?wid=316&fit=constrain",
    passion: "ski",
  },
  {
    label: "Music",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/mc-tricc-jazz-musicians-23095?wid=316&fit=constrain",
    passion: "music",
  },
  {
    label: "Golf",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/mc-wasbd-golf-course-35141",
    passion: "golf",
  },
  {
    label: "Culinary",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/fp-aklfp-wine-dinner-20235?wid=316&fit=constrain",
    passion: "culinary",
  },
  {
    label: "Spa",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/jw-chqmj-spa-beauty-massage-35456",
    passion: "spa",
  },
];
